import React, { useState } from 'react';
import FinancialTracking from './FinancialTracking';
import { buildCampaignSimulation, campaignSimulationEnabled } from './campaignSimulationData';
import { buttonClass, fieldClass } from './shared';

export default function CampaignSimulation({ onOpenChange } = {}) {
  const allowed = campaignSimulationEnabled({
    hostname: typeof window === 'undefined' ? '' : window.location.hostname,
    environment: process.env.REACT_APP_ENVIRONMENT || '',
    enabled: process.env.REACT_APP_CAMPAIGN_SIMULATION_ENABLED || '',
  });
  const [opened, setOpened] = useState(false);
  const [stage, setStage] = useState('before');
  const [now, setNow] = useState(() => new Date());
  if (!allowed) return null;
  const data = opened ? buildCampaignSimulation(stage, now) : null;
  return <section aria-label="Campaign simulation" className="w-full min-w-0 space-y-3">
    <button type="button" className={buttonClass} onClick={() => { setOpened(!opened); onOpenChange?.(!opened); setStage('before'); setNow(new Date()); }} aria-expanded={opened}>Simulate campaign (homologation)</button>
    {opened && <div className="w-full min-w-0 space-y-4 rounded-md border-2 border-orange-300 bg-white p-4">
      <div role="status" className="rounded bg-orange-50 p-3 text-sm"><strong>SIMULATION - fictitious data</strong><p>This preview sends no messages and changes no real invoices, campaigns or payments.</p></div>
      <div className="flex flex-wrap items-end gap-3">
        <label className="text-xs">Simulation scenario<select className={fieldClass} value={stage} onChange={event => { setStage(event.target.value); setNow(new Date()); }}><option value="before">Before payments</option><option value="partial">Some paid and partially paid</option><option value="paid">All invoices paid</option></select></label>
        <button type="button" className={buttonClass} onClick={() => { setStage('before'); setNow(new Date()); }}>Reset simulation</button>
        <button type="button" className={buttonClass} onClick={() => { setOpened(false); onOpenChange?.(false); }}>Close simulation</button>
      </div>
      <FinancialTracking tracking={data.tracking} messageSummary={data.messageSummary} messages={data.messages} category="financial" onRefresh={() => setNow(new Date())} />
    </div>}
  </section>;
}
